export const initialState = {
  customers: []
}

export default function(state=initialState, action) {
  const { payload, type } = action

  switch(type) {
    case 'CUSTOMERS_LOAD_SUCCEEDED':
      return {
        ...state,
        customers: payload.data
      }
    case 'CHANGE_MEMBERSHIP_SUCCEEDED':
      const activeMembership = payload.activeMembership
      return {
        ...state,
        customers: (state.customers || []).map(customer => {
          if (customer.id === activeMembership.customer_id)
            customer.active_membership = activeMembership

          return customer
        })
      }
    default:
      return state
  }
}
